import React, { useState } from "react";
import axios from "../utils/axios";
import { getUserInfo } from "../utils/auth";
import { useHistory } from "react-router";
import { ToastContainer } from "react-toastr";

export default function ChangePassword() {
  const history = useHistory();
  const [password, setPassword] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = getUserInfo();
    await axios()
      .put(`/users/${user.userCode}`, { password })
      .then(async ({ data }) => {
        // login(JSON.parse(config.data).code)
        // await login(data.token, null, null);
        console.log(data);
        container.success(`Change password succesfully`, null, {
          timeOut: 500,
        });
        // return data.token;
      })
      .catch((err) => {
        container.error(`Error when changing password: ${err.message}`);
        console.log(err);
      });
    setTimeout(() => {
      history.push("/home");
    }, 500);
  };

  const handleChange = (e) => {
    e.persist();
    setPassword(e.target.value);
  };

  let container;

  return (
    <div className="d-flex justify-content-center align-items-center h-full">
      <ToastContainer
        ref={(ref) => (container = ref)}
        className="toast-top-right"
      />
      <div className="card m-2">
        <div className="card-body login-card-body">
          <p className="login-box-msg">Fill in your new pasword</p>
          <form onSubmit={handleSubmit}>
            <div className="input-group mb-3">
              <input
                type="password"
                onChange={handleChange}
                className="form-control"
                placeholder="New Password"
              />
              <div className="input-group-append">
                <div className="input-group-text">
                  <span className="fas fa-lock" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <button type="submit" className="btn btn-primary btn-block">
                  Submit
                </button>
              </div>
              {/* /.col */}
            </div>
          </form>
        </div>
        {/* /.login-card-body */}
      </div>
    </div>
  );
}
